export default __webpack_public_path__ + "static/media/2167.98de7938.png";